import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class IaReportService {
  baseUrl = environment.apiUrl + 'Copilot/';
  baseUrl2 = environment.apiUrl + 'Report/';

  constructor(
    private http: HttpClient,
    private router: Router,
    private _location: Location
  ) {}

  getAllIaReports(
    page: number,
    pageSize: number,
    filters
  ): Observable<HttpResponse<any[]>> {
    return this.http.get<any[]>(
      this.baseUrl + `alerts?pg=${page}&pageSize=${pageSize}`,
      {
        observe: 'response',
        params: filters,
      }
    );
  }

  getCopilotAlertsCount(filters): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.baseUrl + `alerts/count`, {
      observe: 'response',
      params: filters,
    });
  }

  generateGeneralIaReport(filters, language): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.baseUrl2 + `copilot?culture=${language}`, {
      observe: 'response',
      params: filters,
    });
  }

  generateEvoIaReport(filters, language): Observable<HttpResponse<any>> {
    return this.http.get<any>(
      this.baseUrl2 + `copilot-evo?culture=${language}`,
      { observe: 'response', params: filters }
    );
  }
}
